import React from "react";
import PropTypes from "prop-types";

import { Label } from "semantic-ui-react";

const DeltaLabel = ({ deltaQty, children }) => {
  if (!deltaQty) return null;

  return (
    <React.Fragment>
      {" "}
      <Label
        size="small"
        color={deltaQty > 0 ? "green" : "blue"}
        circular
        style={{ width: "fit-content" }}
      >
        {deltaQty > 0 && "+"}
        {children || deltaQty}
      </Label>
    </React.Fragment>
  );
};

DeltaLabel.propTypes = {
  deltaQty: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
};

DeltaLabel.defaultProps = { deltaQty: undefined, children: null };

export default DeltaLabel;
